import React, { useMemo } from 'react';
import T from 'prop-types';
import { isEmpty, map, mapValues } from 'lodash-es';

import { SmartChart } from '../../../../../../components/Chart';
import Skeleton from '../../../../../../components/Skeleton';
import { columnChartConfig, colors } from './config';
import { advancedPartialFilters } from '../../../configs/chart-config';

const emptyObject = {};

const ConcentrationChart = ({ series, apps, chartType, isPending, isPress }) => {
  const sortedSeries = useMemo(() => {
    if (isEmpty(series)) return emptyObject;

    return apps.reduce(
      (acc, app) => ({
        ...acc,
        [app.unified_ref_no]: series[app.unified_ref_no] || [],
      }),
      {}
    );
  }, [apps, series]);

  const appByRefNo = apps.reduce(
    (acc, app, index) => ({
      ...acc,
      [app.unified_ref_no]: { ...app, color: colors[index] },
    }),
    {}
  );

  const metaSeries = mapValues(sortedSeries, (_, appRefNo) => ({
    appRefNo,
    type: chartType,
    color: appByRefNo[appRefNo]?.color,
    name: `${appByRefNo[appRefNo]?.nickname || 'Unknown'}`,
    visible: true,
  }));

  const chartConfig = columnChartConfig({
    series: sortedSeries,
    isPress,
  });

  return isPending ? (
    <Skeleton height={322} className="d-flex" />
  ) : (
    <>
      <SmartChart
        chartId="concentration-chart"
        type="stockChart"
        series={sortedSeries}
        metaSeriesData={metaSeries}
        config={chartConfig}
        allowPartialPeriods
        filters={advancedPartialFilters}
      />
      <div className="dashboard-legend">
        {map(metaSeries, (item) => (
          <div key={item.appRefNo} className="dashboard-legend__item">
            <span className="dashboard-legend__marker" style={{ backgroundColor: item.color }} />
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    </>
  );
};

ConcentrationChart.propTypes = {
  series: T.object.isRequired,
  apps: T.array.isRequired,
  chartType: T.oneOf(['spline', 'column']),
  isPending: T.bool,
  isPress: T.bool,
};

export default ConcentrationChart;
